import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-095ba4cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height"]

import { computed, ref } from 'vue';

/**
 * TYPES
 */
type Props = {
  noFade?: boolean;
  width?: string;
  height?: string;
};

/**
 * PROPS & EMITS
 */

export default /*#__PURE__*/_defineComponent({
  props: {
    noFade: { type: Boolean, default: false },
    width: { default: 'auto' },
    height: { default: 'auto' }
  },
  setup(__props: any) {

const props = __props as { noFade: boolean, width: string, height: string }



/**
 * STATE
 */
const loaded = ref(props.noFade);

/**
 * COMPUTED
 */
const wrapperStyles = computed(() => ({
  width: props.width,
  height: props.height,
}));

/**
 * METHODS
 */
function onLoaded() {
  loaded.value = true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "bal-image-wrapper",
    style: _normalizeStyle(_unref(wrapperStyles))
  }, [
    _createVNode(_Transition, { name: "bal-image-fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("img", _mergeProps({
          width: props.width,
          height: props.height
        }, _ctx.$attrs, { onLoad: onLoaded }), null, 16, _hoisted_1), [
          [_vShow, loaded.value]
        ])
      ]),
      _: 1
    })
  ], 4))
}
}

})